import React, { useState, useEffect } from "react";
import { FaSearch } from "react-icons/fa";
import "./PayIn.css";
import { IoReload } from "react-icons/io5";
import { useSelector } from "react-redux";
import { getSelfUser } from "../../config/LiveApi";
import DateFilter from "../../components/common/DateFilter";

function ReportHeader({
  currentPage,
  currentItems,
  setSearchType,
  searchType,
  setSearchText,
  searchText,
  hitFetchApi,
  fetchData,
  setParentStartDate,
  setParentEndDate,
}) {
  const token = useSelector((store) => store.userReducer.token);
  const [minDate, setMinDate] = useState(null);

  const handleChange = (e, setSearchText) => {
    setSearchText(e.target.value);
  };

  const reloadfunction = () => {
    window.location.reload();
  };

  useEffect(() => {
    const fetchMinDate = async () => {
      if (role === "admin" || role === "super" || role === "subSuper") {
        const response = await getSelfUser(token);

        setMinDate(new Date(response.createdAt));
      }
    };

    fetchMinDate();
  }, []);

  const handleDateChange = (start, end) => {
    setParentStartDate(start);
    setParentEndDate(end);

    // OPTIONAL: fetch data immediately
    // fetchData(token, currentPage, "", start, end);
  };

  return (
    <div>
      <div className="manage-header-report">
        <h2 className="area-top-title-report">Payin Report</h2>
      </div>
      <DateFilter onDateChange={handleDateChange} />
      <div className="search-divs-report">
        <div className="search-report">
          <input
            type="text"
            value={searchText}
            className="search-input-report"
            placeholder="Search"
            onChange={(e) => handleChange(e, setSearchText)}
          />
          <FaSearch className="search-icon-report" />
        </div>
        {/* <ReactSelect
          options={options}
          className="search-select"
          onChange={(e) => setSearchType(e.value)}
        /> */}

        <button
          className="go-btn"
          onClick={() => hitFetchApi(searchType, searchText)}
        >
          Go
        </button>
        <button className="reload-btn" onClick={() => reloadfunction()}>
          <IoReload />
        </button>
      </div>
    </div>
  );
}

export default ReportHeader;
